import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ui-popup-body',
  templateUrl: './popup-body.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupBodyComponent {
  @Input() backgroundWhite = false;
}
